/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditPricePage,
    openDeletePriceDialog,
  }
) => (
  <>
    <>
      <a
        title="Edit Price"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditPricePage(row._id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            title="Edit Price"
          />
        </span>
      </a>
      <a
        title="Delete Price"
        className="btn btn-icon btn-light btn-hover-info btn-sm"
        onClick={() => openDeletePriceDialog(row._id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} title="Delete Price"/>
        </span>
      </a>
    </>
  </>
);
